module.exports = __webpack_public_path__ + "img/red_041.a4217cfa.png";